import React from "react";

const IEPage = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "100vh",
        padding: "50px",
        backgroundColor: "#F6FCFF",
        fontFamily:
          '"Open Sans",-apple-system,"Segoe UI","Roboto","Oxygen","Ubuntu","Cantarell","Fira Sans","Droid Sans","Helvetica Neue","Helvetica","Arial",sans-serif',
      }}
    >
      <h2
        style={{
          textAlign: "center",
        }}
      >
        This page requires an up-to-date version of Chrome, Microsoft Edge,
        Firefox, or Safari.
      </h2>
      <p>
        To access the old administration page using other browsers, click here{" "}
        <a href="https://app.pacerpro.com/organization">
          app.pacerpro.com/organization
        </a>
      </p>
    </div>
  );
};

export default IEPage;
